module.exports = __webpack_public_path__ + "static/media/ppe.caf9b86f.svg";